import { CSSProperties, FC, useState } from 'react'
import QRCode from 'react-qr-code'
import { toAbsoluteUrl } from '../../helpers'

type Props = {
  href: string
  img: string
  alt: string
  height?: number
  qrSize?: number
  style?: CSSProperties
}

const StoreBadge: FC<Props> = ({ href, img, alt, height = 60, qrSize = 140, style }) => {
  const [hover, setHover] = useState(false)
  const logoSize = Math.round(qrSize * 0.32)

  return (
    <span
      style={{ position: 'relative', display: 'inline-block', lineHeight: 0, ...style }}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <a href={href} target='_blank' rel='noopener noreferrer' className='d-inline-block'>
        <img
          src={toAbsoluteUrl(img)}
          alt={alt}
          style={{ height, width: 'auto', display: 'block', borderRadius: 10 }}
        />
      </a>

      {hover && (
        <span
          style={{
            position: 'absolute',
            bottom: 'calc(100% + 12px)',
            left: '50%',
            transform: 'translateX(-50%)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 8,
            background: '#fff',
            padding: 12,
            borderRadius: 10,
            boxShadow: '0 6px 24px rgba(0, 0, 0, 0.18)',
            zIndex: 1050,
          }}
        >
          <span style={{ position: 'relative', width: qrSize, height: qrSize, lineHeight: 0 }}>
            <QRCode
              value={href}
              size={qrSize}
              level='H'
              viewBox='0 0 256 256'
              style={{ width: qrSize, height: qrSize, display: 'block' }}
            />
            <span
              style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                background: '#fff',
                borderRadius: 6,
                padding: 3,
                display: 'flex',
              }}
            >
              <img
                src={toAbsoluteUrl('/media/logos/Netway-logo.png')}
                alt='Netway'
                style={{ width: logoSize, height: logoSize, display: 'block' }}
              />
            </span>
          </span>

          <span
            style={{
              fontSize: 12,
              lineHeight: 1.3,
              color: '#3f4254',
              textAlign: 'center',
              whiteSpace: 'nowrap',
            }}
          >
            Telefon kameranız ile tarayın
          </span>

          <span
            style={{
              position: 'absolute',
              top: '100%',
              left: '50%',
              transform: 'translateX(-50%)',
              width: 0,
              height: 0,
              borderLeft: '8px solid transparent',
              borderRight: '8px solid transparent',
              borderTop: '8px solid #fff',
            }}
          />
        </span>
      )}
    </span>
  )
}

export default StoreBadge
